import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.add_bank_details_title',
        defaultMessage: 'Add your business bank details'
    },
    caption: {
        id: '_.funding_requirements.add_bank_details_caption',
        defaultMessage: 'We’ll send the funds to this account.'
    },
    action: {
        id: '_.funding_requirements.bank_details_action',
        defaultMessage: 'Link Account'
    },
    pending: {
        id: '_.funding_requirements.bank_details_action_pending',
        defaultMessage: 'Pending'
    }
});
